import Vue from "vue";
import "@/plugins/bootstrap-vue";
// import "@/plugins/vue-markdown";
import "@/plugins/axios";
import "@/plugins/axiosEpdpApi";
import "@/plugins/modal-toast";
import { installChunkReloadGuard } from "@/chunk-reload";
import "@/registerServiceWorker";
import router from "@/router/router";
import store from "@/store";
import App from "@/app/app.vue";
import VueMoment from "vue-moment";
import moment from "moment";
import "moment/locale/id";
import PageHeader from "@/components/common/page-header/page-header.vue";
import PiSelect from "@/components/common/pi-select/pi-select.vue";
import PiTable from "@/components/common/pi-table/pi-table.vue";
import PiSearch from "@/components/common/pi-search/pi-search.vue";
import PiSegments from "@/components/common/pi-segments/pi-segments.vue";
import BackToTop from "@/components/common/back-to-top.vue";

// Recover automatically from stale-deploy / poisoned-SW chunk load failures
// (the "Unexpected token '<'" on nav click reported by some clients).
installChunkReloadGuard();

Vue.config.productionTip = false;
Vue.use(VueMoment, {
  moment,
});

// Shared design-system components — usable on any page
Vue.component("page-header", PageHeader);
Vue.component("pi-select", PiSelect);
Vue.component("pi-table", PiTable);
Vue.component("pi-search", PiSearch);
Vue.component("pi-segments", PiSegments);
Vue.component("back-to-top", BackToTop);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
